export const SITE = {
  url: "https://www.felipevilla.dev",
  name: "Felipe Villa",
};

